// extracted by mini-css-extract-plugin
export default {"root":"ToolBar_root__BNpKl","label":"ToolBar_label__jkWx8"};